"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationWrapper = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const applicationWrapperActions = __importStar(require("./redux/walletApplicationWrapperActions"));
const FerrumToken_json_1 = __importDefault(require("../../helper/FerrumToken.json"));
const ferrum_plumbing_1 = require("ferrum-plumbing");
// import { RootState } from "../../redux/rootReducer";
const web3_1 = __importDefault(require("web3"));
const big_js_1 = require("big.js");
const core_1 = require("@web3-react/core");
const getLibrary = (provider, connector) => {
    return new web3_1.default(provider); // this will vary according to whether you use e.g. ethers or web3.js
};
const ApplicationWrapper = ({ children, shouldInitializeCCTBProfile, groupId }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isConnected, walletAddress, currentWalletNetwork, 
    // walletBalance,
    networkClient, isWeb3Initialized, } = (0, react_redux_1.useSelector)((state) => state.walletConnector);
    const { tokenList, walletWrapperInitialized, 
    // supportedCurrencies,
    groupInfo, } = (0, react_redux_1.useSelector)((state) => state.walletApplicationWrapper);
    (0, react_1.useEffect)(() => {
        // console.log("Attempt to intialize app");
        dispatch(applicationWrapperActions.getHttpProviders());
        dispatch(applicationWrapperActions.loadWalletDefaults(groupId, tokenList));
        // eslint-disable-next-line
    }, []);
    (0, react_1.useEffect)(() => {
        if (isConnected && isWeb3Initialized && networkClient && walletWrapperInitialized && shouldInitializeCCTBProfile === true) {
            // console.log(
            //   "Meta mask is connect, web3 intialized, network client is available wallet wrapper is initialized attempt to signin into server"
            // );
            signIntoServer();
        }
        else if (!isConnected || !isWeb3Initialized || !networkClient || !walletWrapperInitialized) {
            // console.log("App Initialization is not valid reset user profile");
            dispatch(applicationWrapperActions.resetUserProfile());
        }
        // eslint-disable-next-line
    }, [isConnected, walletWrapperInitialized]);
    const signIntoServer = () => __awaiter(void 0, void 0, void 0, function* () {
        // console.log("building user profile before sign in");
        const user = yield getUserProfile();
        // console.log("user profile built : ", user);
        // console.log("continue with signin", user);
        dispatch(applicationWrapperActions.getUserProfile(user));
    });
    const getUserProfile = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (networkClient !== undefined) {
            const userTokens = tokenList.filter((item) => {
                return item.chainId === currentWalletNetwork;
            });
            const currentNetwork = (_a = userTokens[0]) === null || _a === void 0 ? void 0 : _a.currency.split(":")[0];
            const currencies = groupInfo.bridgeCurrencies.filter((currency) => currency.split(":")[0] === currentNetwork);
            const addressesF = currencies.map((c) => __awaiter(void 0, void 0, void 0, function* () {
                const [network, tokenAddr] = c.split(":");
                let symbol = "";
                let decimals = "";
                let name = "";
                let amount = 0;
                let balance = 0;
                // let decimalFactor;
                const netObj = ferrum_plumbing_1.Networks.for(network);
                if (network === currentNetwork) {
                    if (netObj.baseSymbol === tokenAddr) {
                        symbol = "";
                        if (!!networkClient) {
                            balance = web3_1.default.utils.fromWei(yield networkClient.eth.getBalance(walletAddress));
                            // console.log(balance, "==================");
                        }
                        else {
                            balance = "0";
                        }
                    }
                    else {
                        // const token = TokenInfo[c];
                        // symbol = token.tokenSymbol;
                        const tokenContract = new networkClient.eth.Contract(FerrumToken_json_1.default.abi, tokenAddr);
                        symbol = yield tokenContract.methods.symbol().call();
                        decimals = (yield tokenContract.methods.decimals().call());
                        name = yield tokenContract.methods.name().call();
                        balance = yield tokenContract.methods.balanceOf(walletAddress).call();
                        const decimalFactor = Math.pow(10, Number(decimals));
                        balance = new big_js_1.Big(balance).div(decimalFactor).toFixed();
                    }
                }
                return {
                    address: walletAddress.toLocaleLowerCase(),
                    addressType: "ADDRESS",
                    balance: balance,
                    currency: c,
                    amount,
                    humanReadableAddress: walletAddress,
                    network: currentNetwork || undefined,
                    pendingForDeposit: "0",
                    pendingForWithdrawal: "0",
                    symbol,
                    decimals,
                    name,
                    addressWithChecksum: walletAddress,
                };
            }));
            const addresses = yield Promise.all(addressesF);
            const accountGroups = {
                id: "ag1",
                addresses,
            };
            const up = {
                appId: "base",
                displayName: "",
                userId: walletAddress,
                accountGroups: [accountGroups],
                currentNetwork,
            };
            return up;
        }
    });
    return react_1.default.createElement(core_1.Web3ReactProvider, { getLibrary: getLibrary }, children);
};
exports.ApplicationWrapper = ApplicationWrapper;
//# sourceMappingURL=walletApplicationWrapper.js.map